var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('notifications',{attrs:{"group":"notify","position":"bottom right","speed":500,"duration":5000,"width":500}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }